import React from 'react'

// ArComponents
import ArHeroHeader from 'src/components/ArHeroHeader/ArHeroHeader'
import ArBenefits from 'src/components/ArBenefits/ArBenefits'
import ArJobsListing from 'src/components/ArJobsListing/ArJobsListing'
import ArPostSimple from 'src/components/ArPostSimple/ArPostSimple'
import ArSeo from 'src/components/ArSeo/ArSeo'

// Data
import DaPageCompanyCareers from 'src/data/PageCompanyCareers'
import routesConfig from 'src/routes.config'

class CareersPage extends React.Component {
  render () {
    return (
      <React.Fragment>
        <ArSeo
          title={DaPageCompanyCareers.metadata.title}
          description={DaPageCompanyCareers.metadata.desc}
          path={routesConfig.company.careers()}
        />

        {(() => {
          const { image, title, cta, description } = DaPageCompanyCareers.ArHeroHeader
          return (
            <ArHeroHeader
              variant="company-careers"
              image={image}
              title={title}
              description={description}
              cta={cta}
            />
          )
        })()}

        {(() => {
          const { items } = DaPageCompanyCareers.ArTextWithImageStacked

          return items.map(({ title, description, image, ...scRest }, index) =>
            <ArPostSimple
              key={index}
              image={image}
              title={title}
              description={description}
              scImageToRight={true}
              scHideMobileImg={true}
              { ...scRest }
            />
          )
        })()}

        {(() => {
          const { title, description, benefits } = DaPageCompanyCareers.ArBenefits

          return (
            <ArBenefits
              title={title}
              description={description}
              benefits={benefits}
            />
          )
        })()}

        {(() => {
          const { title, description, jobs } = DaPageCompanyCareers.ArJobsListing

          return (
            <ArJobsListing
              id="job-propositions"
              title={title}
              description={description}
              jobs={jobs}
            />
          )
        })()}

      </React.Fragment>
    )
  }
}

export default CareersPage
